var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoctorReportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "doctor-report-icon",
    transform: "translate(-993 -305)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_623",
    "data-name": "Rectangle 623",
    width: 40,
    height: 40,
    transform: "translate(993 305)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "doctor-icon",
    d: "M37.856,25.767a5.154,5.154,0,1,0-6.763,4.951A7.449,7.449,0,0,1,16.5,28.664V26.7a2.589,2.589,0,0,0,.466-.354l8.361-8.328.253-.257A7.708,7.708,0,0,0,24.1,5.609,3.815,3.815,0,1,0,20.3,9.756a3.79,3.79,0,0,0,3.013-1.515,5.112,5.112,0,0,1,.415,7.668L15.2,24.414,6.91,16.159,6.643,15.9a5.136,5.136,0,0,1,0-7.3,5.259,5.259,0,0,1,.443-.377A3.788,3.788,0,0,0,10.1,9.731,3.866,3.866,0,1,0,6.3,5.6,7.835,7.835,0,0,0,4.8,6.739,7.752,7.752,0,0,0,4.809,17.77l8.622,8.582a2.563,2.563,0,0,0,.454.35v1.963A10.066,10.066,0,0,0,33.751,30.9,5.228,5.228,0,0,0,37.856,25.767Z",
    transform: "translate(992.882 304.667)",
    fill: "#7aba56"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorReportIcon);
export default __webpack_public_path__ + "static/media/doctor-report-icon.37439e04c44ca8ebc048ab0935f5c02d.svg";
export { ForwardRef as ReactComponent };